// extracted by mini-css-extract-plugin
export default {"root":"app-react-components-form-components-SwitchField-Switch-module__root"};